import { NavConfig } from '../../../../models/configs/navConfig';

export const navConfig: Array<{
    config: NavConfig[],
    spm: string,
}> = [
        {
            spm: 'news',
            config: [
                {
                    'name': '新闻',
                    'link': '//news.sohu.com',
                }, {
                    'name': '时政',
                    'link': '//www.sohu.com/c/8/1460',
                }, {
                    'name': '国际',
                    'link': '//www.sohu.com/c/8/1461',
                }, {
                    'name': '军事',
                    'link': '//mil.sohu.com/',
                }, {
                    'name': '警法',
                    'link': 'http://police.news.sohu.com/',
                }, {
                    'name': '专题',
                    'link': '//www.sohu.com/subject',
                }, {
                    'name': '公益',
                    'link': '//gongyi.sohu.com/',
                }, {
                    'name': '无人机',
                    'link': 'http://wrj.sohu.com/',
                }],
        }, {
            spm: 'sports',
            config: [
                {
                    'name': '体育',
                    'link': '//sports.sohu.com',
                }, {
                    'name': 'NBA',
                    'link': '//sports.sohu.com/s/nba',
                }, {
                    'name': 'CBA',
                    'link': '//sports.sohu.com/s/cba',
                }, {
                    'name': '中超',
                    'link': '//sports.sohu.com/s/csl',
                }, {
                    'name': '国足',
                    'link': '//sports.sohu.com/s/cnmenfootball',
                }, {
                    'name': '英超',
                    'link': '//sports.sohu.com/s/premierleague',
                }, {
                    'name': '西甲',
                    'link': '//sports.sohu.com/s/laliga',
                }, {
                    'name': '意甲',
                    'link': '//sports.sohu.com/s/seriea',
                }, {
                    'name': '欧冠',
                    'link': '//sports.sohu.com/s/uefacl',
                }, {
                    'name': '综合',
                    'link': '//sports.sohu.com/s/integrated',
                }],
        }, {
            spm: 'business',
            config: [
                {
                    'name': '财经',
                    'link': '//business.sohu.com',
                }, {
                    'name': '宏观',
                    'link': '//business.sohu.com/category/macrography',
                }, {
                    'name': '股票',
                    'link': '//q.stock.sohu.com/',
                }, {
                    'name': '金融理财',
                    'link': '//business.sohu.com/category/financial',
                }, {
                    'name': '房地产',
                    'link': '//business.sohu.com/category/realty',
                }, {
                    'name': '搜狐酒业',
                    'link': '//business.sohu.com/category/wine',
                }, {
                    'name': '科创板',
                    'link': '//business.sohu.com/category/kcb',
                }],
        }, {
            spm: 'yule',
            config: [
                {
                    'name': '娱乐',
                    'link': '//yule.sohu.com',
                }, {
                    'name': '明星',
                    'link': '//yule.sohu.com/1406',
                }, {
                    'name': '电影',
                    'link': '//yule.sohu.com/1409',
                }, {
                    'name': '电视剧',
                    'link': '//yule.sohu.com/1408',
                }, {
                    'name': '综艺',
                    'link': '//yule.sohu.com/1410',
                }, {
                    'name': '美图',
                    'link': '//yule.sohu.com/1407',
                }],
        }, {
            spm: 'auto',
            config: [
                {
                    'name': '汽车',
                    'link': '//auto.sohu.com',
                }, {
                    'name': '买车',
                    'link': '//db.auto.sohu.com/home/',
                }, {
                    'name': '车贷',
                    'link': '//00.auto.sohu.com/d/index',
                }, {
                    'name': '二手车',
                    'link': '//2sc.sohu.com',
                }, {
                    'name': '新车',
                    'link': '//db.auto.sohu.com/newcar/',
                }],
        }, {
            spm: 'focus',
            config: [
                {
                    'name': '房产',
                    'link': '//www.focus.cn',
                }, {
                    'name': '新房',
                    'link': '//house.focus.cn/loupan/',
                }, {
                    'name': '文旅',
                    'link': '//wl.focus.cn/',
                }, {
                    'name': '家居',
                    'link': '//home.focus.cn/',
                }, {
                    'name': '租房',
                    'link': '//esf.focus.cn/house/rents',
                }, {
                    'name': '地图找房',
                    'link': '//house.focus.cn/map/',
                }, {
                    'name': '看房团',
                    'link': '//house.focus.cn/kanfangtuan/',
                }, {
                    'name': '房产资讯',
                    'link': '//house.focus.cn/zixun/',
                }],
        }, {
            spm: 'tech',
            config: [
                {
                    'name': '科技',
                    'link': '//it.sohu.com',
                }, {
                    'name': '互联网',
                    'link': '//it.sohu.com/911',
                }, {
                    'name': '通讯',
                    'link': '//it.sohu.com/934',
                }, {
                    'name': '智能硬件',
                    'link': '//it.sohu.com/882',
                }, {
                    'name': '生活服务',
                    'link': '//it.sohu.com/913',
                }, {
                    'name': '创业投资',
                    'link': '//it.sohu.com/881',
                }, {
                    'name': '科学',
                    'link': '//it.sohu.com/category/science/recommend',
                }, {
                    'name': '5G',
                    'link': '//it.sohu.com/category/5G/record',
                }, {
                    'name': '数码',
                    'link': '//it.sohu.com/936',
                }],
        }, {
            spm: 'health',
            config: [
                {
                    'name': '健康',
                    'link': '//health.sohu.com',
                }, {
                    'name': '生活大发现',
                    'link': '//health.sohu.com/category/discover',
                }, {
                    'name': '食话食说',
                    'link': '//health.sohu.com/category/diet',
                }, {
                    'name': '图说健康',
                    'link': '//health.sohu.com/category/picture',
                }, {
                    'name': '健康白皮书',
                    'link': '//health.sohu.com/category/whitebook',
                }, {
                    'name': '生命科学',
                    'link': '//health.sohu.com/category/cosmedical',
                }, {
                    'name': '搜狐医药',
                    'link': '//health.sohu.com/category/medhelp',
                }, {
                    'name': '健康主题日',
                    'link': '//health.sohu.com/category/themeday',
                }, {
                    'name': '搜狐名医',
                    'link': '//health.sohu.com/category/doctor',
                }],
        }, {
            spm: 'fashion',
            config: [
                {
                    'name': '时尚',
                    'link': '//fashion.sohu.com',
                }, {
                    'name': '时装',
                    'link': '//fashion.sohu.com/1045',
                }, {
                    'name': '奢品',
                    'link': '//fashion.sohu.com/1057',
                }, {
                    'name': '美容',
                    'link': '//fashion.sohu.com/1051',
                }, {
                    'name': '人物',
                    'link': '//fashion.sohu.com/1062',
                }, {
                    'name': '荷尔蒙',
                    'link': '//fashion.sohu.com/1080',
                }, {
                    'name': '男士',
                    'link': '//fashion.sohu.com/1068',
                }, {
                    'name': '生活方式',
                    'link': '//fashion.sohu.com/1073',
                }],
        }, {
            spm: 'learning',
            config: [
                {
                    'name': '教育',
                    'link': '//learning.sohu.com',
                }, {
                    'name': '高考',
                    'link': '//learning.sohu.com/category/gaokao',
                }, {
                    'name': '家长帮',
                    'link': '//learning.sohu.com/category/parent',
                }, {
                    'name': '中小学',
                    'link': '//learning.sohu.com/category/zxx',
                }, {
                    'name': '高校',
                    'link': '//learning.sohu.com/category/college',
                }, {
                    'name': '留学',
                    'link': '//learning.sohu.com/category/studyabroad',
                }, {
                    'name': '考试',
                    'link': '//learning.sohu.com/category/exam',
                }],
        }, {
            spm: 'others',
            config: [
                {
                    'name': '其他',
                    'link': '',
                }, {
                    'name': '军事',
                    'link': '//mil.sohu.com',
                }, {
                    'name': '专题',
                    'link': '//www.sohu.com/subject',
                }, {
                    'name': '文化',
                    'link': '//cul.sohu.com',
                }, {
                    'name': '历史',
                    'link': '//history.sohu.com',
                }, {
                    'name': '美食',
                    'link': '//chihe.sohu.com',
                }, {
                    'name': '星座',
                    'link': '//astro.sohu.com',
                }, {
                    'name': '旅游',
                    'link': '//travel.sohu.com',
                }, {
                    'name': '母婴',
                    'link': '//baobao.sohu.com',
                }, {
                    'name': '动漫',
                    'link': 'https://www.sohu.com/topic/acg',
                }, {
                    'name': '游戏',
                    'link': '//game.sohu.com',
                }, {
                    'name': '爱美',
                    'link': 'https://www.sohu.com/topic/love',
                }],
        },
    ];



// WEBPACK FOOTER //
// ./src/pages/HomePageV2/components/WebsiteMap/navConfig.ts